import styled from "styled-components";

export const Wrapper = styled.div`
  .new-access-container {
    border: 1px solid #dddddd;
    border-radius: 5px;
    position: relative;
    left: -5px;
    height: 78vh;
  }
  .sub-access-container {
    border: 1px solid #dddddd;
    border-radius: 5px;
    position: relative;
    left: 5px;
  }
  .header-conatiner {
    padding: 20px 20px 30px 10px;
    h5 {
      font-size: 25px;
      font-weight: bold;
      margin: 0px;
      color: #343232ed;
    }
  }
  .label-col {
    height: 100%;
    margin-top: 13px;

    label {
      color: #566787;
      font-size: 17px;
    }
  }
  .input-container {
    border: 1px solid #dddddd;
  }
  .ant-select-selector {
    border: 1px solid #dddddd !important;
    font-size: 20px;
    height: 49px !important;
    input {
      margin-top: 9px !important;
    }
  }
  .ant-select-selection-placeholder {
    padding-top: 5px;
  }
  .ant-select-selection-item{
    div{
      margin-top: 8px;
    }

  }
  @media screen and (max-width: 1000px) {
    .new-access-container {
      height: auto;
    }
    .label-col {
      label {
        font-size: 15px;
      }
    }
    .sub-access-container {
      left: -5px;
    }
  }
`;
